<form>
	<ui-modal [modalTitle]="reservationId ? 'Edit Reserved Items' : 'Add Reserved Item'" size="md">
		<div *ngIf="product?.warehouse_sku" class="text-secondary text-small" ui-modal-sub-header>
			<i class="wq wq-warehouse mr-1"></i>SKU: {{product.warehouse_sku}}
		</div>

		<ui-form labelWidth="8rem">
			<div *ngIf="details">
				<ui-form-control label="Reserve Stock For">
					<select
						class="custom-select"
						[(ngModel)]="selectedUserId"
						(ngModelChange)="onUserChange($event)"
						[ngModelOptions]="{ standalone: true }"
					>
						<option [ngValue]="null"></option>
						<option *ngFor="let u of userList" [ngValue]="u.id">{{u.name}}</option>
					</select>
				</ui-form-control>
				<ui-form-control label="Quantity">
					<div class="d-flex align-items-center">
						<div class="input-group w-40">
							<input type="text" class="form-control text-right" (ngModelChange)="setDirty()" [(ngModel)]="details.quantity" [ngModelOptions]="{ standalone: true }" (change)="onQuantityChange()" />
							<div *ngIf="details.unit_name" class="input-group-append">
								<span class="input-group-text">{{details.unit_name}}</span>
							</div>
						</div>
						<div class="ml-2">
							<span class="text-success">Stock Available: {{ product?.quantity_available }} {{details.unit_name}} </span>
						</div>
					</div>
				</ui-form-control>
				<ui-form-control label="Reservation Notes">
					<textarea rows="3" class="form-control" (ngModelChange)="setDirty()" [(ngModel)]="details.notes" [ngModelOptions]="{ standalone: true }"></textarea>
				</ui-form-control>
				<hr>
				<label class="custom-control custom-checkbox d-inline-block mt-2 mb-1">
					  <input
						type="checkbox"
						class="custom-control-input"
						[ngModel]="!!details.reserve_for_project"
						(ngModelChange)="onReserveForProjectChange($event)"
						[ngModelOptions]="{ standalone: true }"
					>
					<span class="custom-control-label selectable">Reserve For a Project</span>
				</label>
				<ui-form-control label="Project" *ngIf="details.reserve_for_project">
					<div class="d-flex align-items-center">
						<input class="form-control" [(ngModel)]="details.project" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off" readonly (click)="selectProject()">
						<button type="button" class="btn btn-outline-secondary p-2 ml-1" (click)="selectProject()" ngbTooltip="Select Project"><i class="wq wq-search"></i></button>
						<button *ngIf="details.project_id" (click)="goToProject()" type="button" class="btn btn-outline-info px-2 ml-1" ngbTooltip="Go To Project"><i class="wq wq-open-new"></i></button>
						<button type="button" class="btn btn-outline-success px-2 ml-1" (click)="addNewProject()" ngbTooltip="Add New Project"><i class="wq wq-add"></i></button>
						<button type="button" *ngIf="details.project_id" class="btn btn-outline-secondary px-2 ml-1" (click)="removeProject()" ngbTooltip="Remove Project"><i class="wq wq-close"></i></button>
					</div>
				</ui-form-control>
			</div>
		</ui-form>

		<div class="flex-weight-1" ui-modal-footer></div>
		<button type="button" class="btn btn-secondary" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
		<button type="submit" class="btn btn-primary" (click)="save()" [disabled]="disabled || !selectedUserId" ui-modal-footer>Save</button>
	</ui-modal>
</form>

<app-modal-select-project (close)="projectSelectModalClosed($event)"></app-modal-select-project>
<modal-edit-project (close)="projectSelectModalClosed($event)"></modal-edit-project>
